module.exports = __webpack_public_path__ + "static/img/803_phase_function_Paper_Points.ffca31b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/803_phase_function_Paper_Points.png
// module id = cR4y
// module chunks = 0